module.exports = __webpack_public_path__ + "img/Karpicko_tlo_2021_v3.1f43b5e0.png";